import React from "react";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Agents from "@/components/Agents";
import Why from "@/components/Why";
import Process from "@/components/Process";
import Results from "@/components/Results";
import Footer from "@/components/Footer";
import Assistant from "@/components/Assistant";
import DemoGallery from "@/components/DemoGallery";
import BookCallDialog from "@/components/BookCallDialog";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <Nav />
      <main>
        <Hero />
        <Agents />
        <Services />
        <Why />
        <Process />
        <Results />
      </main>
      <Footer />
      <Assistant />
      <DemoGallery />
      <BookCallDialog />
    </div>
  );
}

export default App;
